import { Grid } from '@mui/material';
import { throttle } from "lodash";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Scrolleddown from '../../../../animation/jobs/dropdown icon.svg';
import RightArrow from '../../../../animation/jobs/Right arrow.svg';
import SaveTickIcon from '../../../../animation/jobs/save_tickicon.svg';
import Scrolledup from '../../../../animation/jobs/scrolling icon.svg';
import TickIcon from '../../../../animation/jobs/tick icon - full time.svg';
import { addToApplied, saveJob } from "../../../../redux/actions/jobs";
import { ServiceApi } from '../../Service/ServiceApi';
import jobUtils from '../../utils/jobUtils';
import ApplyPopup from './ApplyPopup';
import SavePopup from './SavePopup';

import styles from './JobDetail.module.css';


// Capitalize words
const capitalizeWord = (word) => {
  const w = String(word || "").trim();
  if (!w) return "";
  return w.charAt(0).toUpperCase() + w.slice(1);
};

// Format skills into readable list
const formatSkills = (skills) => {
  if (!skills) return "";
  const arr = Array.isArray(skills)
    ? skills
    : String(skills).split(",").map((s) => s.trim()).filter(Boolean);

  return arr.map(capitalizeWord).join(", ");
};

const JobDetail = ({ job, savedJobs, saveJob, addToApplied }) => {
  if (!job) return <div className={styles.noJobSelected}>Select a job to view details</div>;

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [showSavePopup, setShowSavePopup] = useState(false);
  const containerRef = useRef(null);

  const [resumePreviewUrl, setResumePreviewUrl] = useState(null);
  const [showResumePreview, setShowResumePreview] = useState(false);

  var isApplied = !!job.isApplied;
  var isSaved=!!job.isSaved;

  const userData = JSON.parse(localStorage.getItem("userData"));
  const profileId = userData?.profile_id;
  const token = userData?.token;

  const history = useHistory()

  const company = job.CompanyData || {};

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      setToastMessage("");
    }, 3000);
  };

  const handleCloseToast = () => {
    setShowToast(false);
    setToastMessage("");
  };

  const [tailorLoading, setTailorLoading] = useState(false);
  const [fitLoading, setFitLoading] = useState(false);
  const [fitModalOpen, setFitModalOpen] = useState(false);
  const [fitVerdict, setFitVerdict] = useState("");
  const [fitReasoning, setFitReasoning] = useState("");
  const [fitRecommendations, setFitRecommendations] = useState([]);
  const [fitImprovementPath, setFitImprovementPath] = useState("");
  const [fitEncouragingNote, setFitEncouragingNote] = useState("");

  const handleTailorResume = async () => {
    try {
      setTailorLoading(true);
      const previewUrl = await ServiceApi.TailorResume(token, job.id);
      setResumePreviewUrl(previewUrl);
      setShowResumePreview(true); // Show modal
    } catch (err) {
      console.error("TailorResume Error:", err);
      showToastMessage("Failed to tailor resume. Please try again.");
    } finally {
      setTailorLoading(false);
    }
  };

  const handleFitForThisJob = async () => {
    try {
      setFitLoading(true);
      const res = await ServiceApi.FitForThisJob(token, job.id);

      const data = res?.data || null;

      const verdictText =
        data?.Verdict?.text || res?.verdict || res?.message || "";

      const reasoningText =
        data?.Reasoning?.text || data?.Reasoning || "";

      const recommendationsText =
        data?.Recommendations?.text || data?.Recommendations || "";

      const improvementPathText =
        data?.Improvement_path?.text || data?.Improvement_path || "";

      const encouragingNoteText =
        data?.encouraging_note?.text || data?.encouraging_note || "";

      setFitVerdict(String(verdictText || "").trim());
      setFitReasoning(String(reasoningText || "").trim());
      const recLines = String(recommendationsText || "")
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean);

      setFitRecommendations(recLines);
      setFitImprovementPath(String(improvementPathText || "").trim());
      setFitEncouragingNote(String(encouragingNoteText || "").trim());

      setFitModalOpen(true);
    } catch (err) {
      console.error("FitForThisJob Error:", err);
      showToastMessage("Failed to analyze job fit. Please try again.");
    } finally {
      setFitLoading(false);
    }
  };

  // Save job handler
  const handleSave = async () => {
    try {
      if (!isSaved) {
        // Call API to save        
        const response = await ServiceApi.SavedApi(token, profileId, job.id, "saved");
        if (response.data?.id) {
          setShowSavePopup(true);
          job.isSaved=true;
          job.userjobInfo=response.data.id;
          saveJob(job);
        }
      } else {
      const response = await ServiceApi.DiscardApi(token, job.userjobInfo);
      if (response.status) {
        job.isSaved = false;
        saveJob(job);
        showToastMessage("Job unsaved successfully");
      }
    }
    } catch (error) {
      console.error("Save error:", error);
    }
  };

  const handleConfirmSave = () => {
    saveJob({ ...job, isSaved: true });
    setShowSavePopup(false);
  };


  // Apply handler
  const handleEasyApply = () => {
    if (isApplied) {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 1000);
    } else {
      setOpen(true);
    }
  }

  const handleCloseApplyPopup = () => {
    setOpen(false);
  };


  function cleanJobDescription(text) {
    return text
      .replace(/[\n\r]+/g, " ")
      .replace(/[-•*]\s*/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }



  // Sticky header scroll
  useEffect(() => {
    const handleScroll = throttle(() => {
      if (!containerRef.current) return;
      setIsScrolled(containerRef.current.scrollTop > 200);
    }, 50);

    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scroll = (amount) => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ top: amount, behavior: "smooth" });
    }
  };

  return (
    <div className={styles.jobdetailsParent}>
      <div className={`${styles.scrolledHeader} ${isScrolled ? styles.active : ""}`}>
        <div className={styles.scrollHeaderInnerDiv}>
          <div className={styles.jobDetails}>
            <h2 className={styles.jobTitleHeader}>{job?.title}</h2>
            <p className={styles.jobLocationHeader}>{company?.company_address}</p>
          </div>
          <div className={styles.applySection}>
            {isApplied ? (
              // When applied
              <span className={styles.appliedText}>
                <span className={styles.appliedIconWrapper}>
                  <img src={TickIcon} alt="Applied" />
                </span>
                <span>
                  Applied {jobUtils.timeAgo(job?.isApplied?.applied_at)}
                </span>
              </span>
            ) : (
              // When not applied → show Apply + Save buttons
              <>
                <button
                  className={styles.easyApplyButton}
                  onClick={handleEasyApply}
                  disabled={isApplied}
                >
                  Apply
                </button>
                <button
                  className={`${styles.saveButton} ${isSaved ? styles.saved : ""}`}
                  onClick={handleSave}
                >
                  {isSaved ? "Saved" : "Save"}
                </button>
              </>
            )}
          </div>

        </div>

      </div>
         {showSavePopup && <SavePopup onClose={handleConfirmSave} />}
      <img
        src={Scrolledup}
        onClick={() => scroll(-100)}
        className={styles.arrow_up}
      />
      <div
        ref={containerRef}
        className={`${styles.jobDetailContainer} ${isScrolled ? styles.jobDetailContainerScrolled : ""}`}
      >
        {/* Main job section */}
        <div className={styles.jobWrapper}>
          <div className={styles.jobHeader}>
            <div className={styles.companyInfo}>
              {job?.CompanyData.company_logo ? (
                <img
                  src={jobUtils.decodeIfProxy(job?.CompanyData?.company_logo) || '/Image/fallback-company.png'}
                  alt={`${job?.CompanyData?.company_name ?? 'Company'} logo`}
                  className={styles.companyLogo}
                  onError={(e) => {
                    const img = e.currentTarget;
                    if (img.src && img.src.includes('/media/')) {
                      const decoded = decodeIfProxy(job?.CompanyData?.company_logo);
                      if (decoded && decoded !== img.src) {
                        img.onerror = null;
                        img.src = decoded;
                        return;
                      }
                    }
                    img.onerror = null;
                    img.src = '/Image/fallback-company.png';
                  }}
                />
              ) : (
                <div className={styles.companyDetailLogo}>
                  {company?.company_name?.charAt(0)?.toUpperCase()}
                </div>
              )}
              <h4 className={styles.companyName}>{company?.company_name}</h4>
            </div>
          </div>

          <div className={styles.jobInfo}>
            <h1 className={styles.jobTitle}>{job?.title}</h1>
            <div className={styles.locationInfo}>
              <span>{company?.company_address}</span> •{" "}
              <span>{jobUtils.timeAgo(job?.timestamp)}</span>
            </div>
            <div className={styles.badges}>
              {job?.remote && job?.remote !== "NA" && (
                <button className={styles.remoteBadge}>
                  <img src={SaveTickIcon} width={20} height={16} />
                  {job.remote === "onsite"
                    ? <span class="site-class">On-site</span>
                    : job.remote === "remote"
                      ? <span class="site-class">Remote</span>
                      : null
                  }
                </button>
              )}
              {job?.type && job?.type !== "NA" && (
                <button className={styles.fullTimeBadge}>
                  <img src={SaveTickIcon} width={20} height={16} />
                  {job.type === "fulltime" ? <span class="site-class">Full-time</span> : <span class="site-class">Part-time</span>}
                </button>
              )}
            </div>
            <div className={styles.applySection}>
              {isApplied ? (
                // When applied
                <span className={styles.appliedText}>
                  <span className={styles.appliedIconWrapper}>
                    <img src={TickIcon} alt="Applied" />
                  </span>
                  <span>
                    Applied {jobUtils.timeAgo(job?.isApplied?.applied_at)}
                  </span>
                  <span className={styles.seeApplication} onClick={() => history.push({ pathname: '/savejob/progress', state: { activeTab: 'progress' } })}>
                    See Application <img src={RightArrow} alt="Right arrow" />
                  </span>
                </span>


              ) : (
                // When not applied → show Apply + Save buttons
                <>
                  <button
                    className={styles.easyApplyButton}
                    onClick={handleEasyApply}
                    disabled={isApplied}
                  >
                    Apply
                  </button>
                  <button
                    className={`${styles.saveButton} ${isSaved ? styles.saved : ""}`}
                    onClick={handleSave}
                  >
                    {isSaved ? "Saved" : "Save"}
                  </button>
                </>
              )}
            </div>
          </div>
          
               {showSavePopup && <SavePopup onClose={handleConfirmSave} />}

                {showToast && (
                  <div className={styles.toastCard}><span>{toastMessage}</span>
<span className={styles.closeIcon} onClick={handleCloseToast}>&times;</span>
</div>

  )}
        

          <div className={styles.profileFitSection}>
            <div className={styles.profileFitTitle}>
              How your profile and resume fit this job
            </div>
            <div className={styles.profileFitSubtitle}>
              AI-crafted career insights just for you.
            </div>
            <div className={styles.carouselSection}>
              <button
                className={styles.carouselItem}
                onClick={handleTailorResume}
                disabled={tailorLoading}
              >
                {tailorLoading ? "Tailoring..." : "Tailor my resume to this job"}
              </button>

              <button
                className={styles.carouselItem}
                onClick={handleFitForThisJob}
                disabled={fitLoading}
              >
                {fitLoading ? "Analyzing..." : "Am I a good fit for this job?"}
              </button>

              <Link to="/courses" className={styles.carouselItem}>
                View Training Content
              </Link>

              <a
                href="https://calendly.com/nxnearby/30min"
                className={styles.carouselItem}
                target="_blank"
                rel="noopener noreferrer"
              >
                Schedule Mock Interview
              </a>
            </div>
          </div>

          {/* Job description */}
          <div className={styles.jobDescription}>
            <h3 className={styles.sectionTitle}>About the job</h3>
            {job?.description && (
              <Grid sx={{ mt: 2 }} className={styles.descriptionTitle}>
                <div><b>Description</b></div>
                <div className={styles.descriptionText}>
                  {cleanJobDescription(job.description)}
                </div>
              </Grid>
            )}
          </div>

          {/* Company Info */}
          {company?.company_name && (
            <div className={styles.companyCard}>
              <h3 className={styles.sectionTitle}>About the company</h3>
              <div className={styles.companyContent}>
                <div className={styles.companyHeader}>
                  {jobUtils.decodeIfProxy(company.company_logo) ? (
                    <img
                      src={jobUtils.decodeIfProxy(company.company_logo)}
                      alt={`${company.company_name} logo`}
                      className={styles.company_logo}
                    />
                  ) : (
                    <div className={styles.aboutcompanyDetailLogo}>
                      {company.company_name?.charAt(0)}
                    </div>
                  )}

                  <div className={styles.companyMeta}>
                    <h4 className={styles.companyName}>{company.company_name}</h4>
                    {company.company_address && <div className={styles.companyAddress}>{company.company_address}</div>}
                    {company.company_industry && <div>Industry: {company.company_industry}</div>}
                    {company.company_size && <div>Size: {company.company_size}</div>}
                  </div>

                  {/* Visit website button — renders only if company.website exists */}
                  {company.company_website && (
                    <a
                      href={company.company_website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.visitButton}
                      aria-label={`Visit ${company.company_name} website`}
                    >
                      <span className={styles.visitText}>Visit website</span>
                      <span className={styles.visitIcon} aria-hidden="true">↗</span>
                    </a>
                  )}
                </div>
                <div className={styles.textdescriptionWrapper}>
                  {company?.company_description
                    ? <p className={styles.companytextdescription}>  {cleanJobDescription(company.company_description)}</p>
                    : <p className={styles.companytextdescription}>No company description provided.</p>}
                </div>
              </div>
            </div>
          )}
        </div>

        <img src={Scrolleddown} onClick={() => scroll(100)}
          className={styles.arrow_down} />
      </div>
      {open ? <ApplyPopup
        job={job}
        open={open}
        onClose={handleCloseApplyPopup} 
      /> : ''}

      {fitModalOpen && (
        <div
          className={styles.fitModalOverlay}
          role="dialog"
          aria-modal="true"
          aria-label="Fit Analysis Result"
        >
          <div className={styles.fitModalCard}>
            <button
              className={styles.fitCloseButton}
              aria-label="Close fit analysis"
              onClick={() => setFitModalOpen(false)}
            >
              ×
            </button>

            <div className={styles.fitModalHeader}>
              <h3 className={styles.fitModalTitle}>Fit Analysis</h3>
              <div
                className={`fitVerdictBadge ${
                  fitVerdict
                    ? fitVerdict.toLowerCase().includes("fit")
                      ? "good"
                      : fitVerdict.toLowerCase().includes("average")
                      ? "average"
                      : "bad"
                    : ""
                }`}
                aria-live="polite"
              >
                <span style={{ fontSize: 14 }}>{fitVerdict || "Analysis"}</span>
              </div>
            </div>

            <div className={styles.fitModalGrid}>
              <div className={`${styles.fitColumn} ${styles.fitColumnLeft}`}>
                <section className={styles.fitCard} aria-labelledby="reasoning-title">
                  <h4 id="reasoning-title" className={styles.fitCardTitle}>
                    Reasoning
                  </h4>
                  <div className={styles.fitCardContent}>
                    {fitReasoning ? (
                      <p
                        className={styles.fitReasoningText}
                        style={{ margin: 0, whiteSpace: "pre-wrap" }}
                      >
                        {fitReasoning}
                      </p>
                    ) : (
                      <p
                        className={styles.fitReasoningText}
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No reasoning available.
                      </p>
                    )}
                  </div>
                </section>

                <section
                  className={styles.fitCard}
                  aria-labelledby="improvement-path-title"
                >
                  <h4 id="improvement-path-title" className={styles.fitCardTitle}>
                    Improvement Path
                  </h4>
                  <div className={styles.fitCardContent}>
                    {fitImprovementPath ? (
                      <p
                        className={styles.fitReasoningText}
                        style={{ margin: 0, whiteSpace: "pre-wrap" }}
                      >
                        {fitImprovementPath}
                      </p>
                    ) : (
                      <p
                        className={styles.fitReasoningText}
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No improvement path available.
                      </p>
                    )}
                  </div>
                </section>

                <section
                  className={styles.fitCard}
                  aria-labelledby="summary-title"
                >
                  <h4 id="summary-title" className={styles.fitCardTitle}>
                    Summary &amp; Encouragement
                  </h4>
                  <div className={styles.fitCardContent}>
                    {fitEncouragingNote ? (
                      <p
                        className={styles.fitReasoningText}
                        style={{ margin: 0, whiteSpace: "pre-wrap" }}
                      >
                        {fitEncouragingNote}
                      </p>
                    ) : (
                      <p
                        className={styles.fitReasoningText}
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No note available.
                      </p>
                    )}
                  </div>
                </section>
              </div>

              <div className={`${styles.fitColumn} ${styles.fitColumnRight}`}
>
                <section
                  className={`${styles.fitCard} ${styles.recommendationsCard}`}
                  aria-labelledby="recommendation-title"
                >
                  <h4 id="recommendation-title" className={styles.fitCardTitle}>
                    Recommendations
                  </h4>
                  <div className={styles.fitCardContent}>
                    {fitRecommendations && fitRecommendations.length > 0 ? (
                      <ul className={styles.fitRecommendationList}>
                        {fitRecommendations.map((line, idx) => {
                          const rawLine = String(line || "").trim();
                          return (
                            <li key={idx} className={styles.fitRecommendationItem}>
                              <span className={styles.fitRecommendationText}>
                                {rawLine}
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <p
                        className={styles.fitReasoningText}
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No recommendations available.
                      </p>
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      )}

      {showResumePreview && (
        <div
          className={styles.resumeOverlay}
          role="dialog"
          aria-modal="true"
          aria-label="Tailored resume preview"
        >
          <div className={styles.resumeModal}>
            <button
              className={styles.closeButton}
              aria-label="Close preview"
              onClick={() => {
                if (resumePreviewUrl) window.URL.revokeObjectURL(resumePreviewUrl);
                setShowResumePreview(false);
                setResumePreviewUrl(null);
              }}
            >
              ✕
            </button>

            <div className={styles.resumeHeader}>
              <div>
                <h3 className={styles.resumeTitle}>Tailored Resume Preview</h3>
                <p className={styles.resumeSubtitle}>
                  Make sure everything looks perfect before you download.
                </p>
              </div>
            </div>

            <div className={styles.resumeBody}>
              {resumePreviewUrl ? (
                <div className={styles.resumeFrameWrapper}>
                  <iframe
                    src={resumePreviewUrl}
                    title="Tailored Resume Preview"
                    className={styles.resumeIframe}
                    onLoad={(e) => {
                      e.currentTarget.classList.add(styles.loaded);
                    }}
                  />
                </div>
              ) : (
                <div className={styles.loadingState}>
                  <div className={styles.spinner}></div>
                  <p>Generating your tailored resume…</p>
                </div>
              )}
            </div>

            <div className={styles.resumeFooter}>
              <button
                className={styles.secondaryButton}
                onClick={() => {
                  if (resumePreviewUrl) window.URL.revokeObjectURL(resumePreviewUrl);
                  setShowResumePreview(false);
                  setResumePreviewUrl(null);
                }}
              >
                Close
              </button>
              <button
                className={styles.primaryButton}
                disabled={!resumePreviewUrl}
                onClick={() => {
                  if (!resumePreviewUrl) return;
                  const link = document.createElement("a");
                  link.href = resumePreviewUrl;
                  link.download = "tailored_resume.pdf";
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                }}
              >
                Download PDF
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  savedJobs: state.jobs.savedJobs,
});

const mapDispatchToProps = {
  saveJob,
  addToApplied,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobDetail);